import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './menu.module.scss';
import SignIn from '../signIn/signIn';
import FirstSubMenu from '../subMenu/subMenu';
import SecondSubMenu from '../secondSubMenu/subMenu';

export default function Menu({ navigation = [], signInData = {}, type = '' }) {
  const [isOpen, toggleOpen] = useState(false);
  const [activeSub, setActiveSub] = useState(null);
  const status = isOpen ? styles.close : styles.open;
  const mobileMenuWrapperClass = isOpen ? styles.show : '';
  const toggleState = () => {
    toggleOpen((isOpenState) => !isOpenState);
  };

  return (
    <nav className={styles.menu}>
      <div className={`${styles.list} ${mobileMenuWrapperClass}`}>
        <ul className={styles.navigation}>
          {navigation?.map((menu, index) => {
            const SubMenu =
              type !== 'Patient Solutions' ? SecondSubMenu : FirstSubMenu;
            const key = `menu-${index}`;
            return (
              <SubMenu
                menu={menu}
                key={key}
                isOpen={activeSub === index}
                setIsOpen={(isActive) => {
                  if (isActive) {
                    setActiveSub(index);
                  } else {
                    setActiveSub(null);
                  }
                }}
                onMenuClick={() => toggleOpen(false)}
              />
            );
          })}
        </ul>
      </div>
      <SignIn signInData={signInData} isSubMenuOpen={activeSub} />
      <div
        data-testid="menu-icon"
        role="button"
        onClick={toggleState}
        className={`${status} ${styles.icon}`}
        aria-hidden="true"
      />
    </nav>
  );
}

Menu.propTypes = {
  navigation: PropTypes.array,
  signInData: PropTypes.object,
  type: PropTypes.string,
};
